<!-- 右侧侧滑菜单-->
<template>
  <div class="popover-dialog">
    <el-dialog :visible.sync="isShow" :show-close="false" custom-class="" top="0" :width="width || '30%'" 
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
    >
        <!-- 用来展示侧滑菜单里面的内容 -->
        <slot></slot>
    </el-dialog>
  </div>
</template>
<script>
export default {
    name: 'PopoverRight',
    props: {
      width: String
    },
    data () {
        return {
            isShow: false
        }
    },
    methods: {
        /**  打开侧滑菜单 */
        open () {
            this.isShow = true
        },
        /** 关闭侧滑菜单 */
        hide () {
            this.isShow = false
        }
    }
}
</script>
<style lang="less">
.popover-dialog{
  .el-dialog__wrapper{
      display: -webkit-box;
      -webkit-box-align: end;
      -webkit-box-pack: end;
  }
  .el-dialog{
      margin: 0 0 0 50%;
      border-radius: 2px 0 0 2px;
      height: 100VH;
      box-sizing: border-box;
      overflow-y: scroll;
      &::-webkit-scrollbar{
        width: 2px;
      }
      &::-webkit-scrollbar-track{
        background: #f1f1f1;
      }
      &::-webkit-scrollbar-thumb{
        background: #DCDFE6;
      }
      .el-dialog__header{
        padding: 0;
      }
  }
}
@keyframes dialog-fade-in {
  0% {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
}
</style>